import React from 'react';

import Box from '@mui/material/Box';
import SvgIcon from '@mui/material/SvgIcon';
import { SxProps } from '@mui/system';

import Typography from '@mui/material/Typography';

interface PlaceholderProps {
  logo?: React.ReactElement;
  title: string;
  text: string;
  icon: React.ReactElement;
  innerStyles?: SxProps;
}

const Placeholder = ({
  logo,
  title,
  text,
  icon,
  innerStyles = {},
}: PlaceholderProps) => {
  return (
    <Box sx={{ textAlign: 'center', pt: 8 }}>
      {logo && (
        <Box mb={2}>
          <SvgIcon sx={{ width: 70, height: 70 }}>{logo}</SvgIcon>
        </Box>
      )}
      <Box sx={innerStyles}>
        <Typography variant="h5" sx={{ mb: 1 }}>
          {title}
        </Typography>
        <Typography variant="body1">{text}</Typography>
      </Box>
      <Box my={2}>
        <SvgIcon htmlColor="#d2d5da" sx={{ width: 125, height: 125 }}>
          {icon}
        </SvgIcon>
      </Box>
    </Box>
  );
};

export default Placeholder;
